import {Stack, Text, Box} from '@mantine/core';
import {Hero} from "./Hero";
import {PricingCards} from "./Pricing";
import {FeaturesGrid} from "./Features";
import {FeaturesSection} from "./Steps"
import {Header} from "./Header";
import {AuthenticatedHeader} from "./AuthenticatedHeader";
import React from "react";
import { useAuth } from '../UseAuthHook'; // Import the useAuth hook
import { useViewportSize } from '@mantine/hooks';
import {useNavigate} from 'react-router-dom';
import {Footer} from "./Footer";

export const LandingPage: React.FC = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const { width } = useViewportSize();
    const isMobile = width < 768;
    
    // Calculate header height to add proper spacing
    const headerHeight = isMobile ? 70 : 100;

    return (
        <Stack
            bg="var(--mantine-color-body)"
            align="stretch"
            justify="flex-start"
            gap={0}
            style={{ 
                position: 'relative',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}
        >

            {isAuthenticated? (
                <AuthenticatedHeader
                    onSortClick={() => navigate('/gallery')}
                />
            ) : (
                <Header
                    onLoginClick={() => navigate('/auth/login')}
                    onRegisterClick={() => navigate('/waitlist')}
                />
            )}

            <Box id="hero" style={{ 
                marginTop: headerHeight,
                height: `calc(100vh - ${headerHeight}px)`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                // paddingTop: '8vh' // Adjusted padding to position content at the right height
            }}>
                <Hero callToAction={isAuthenticated ? "Start Organizing" : "Get Started"} 
                      onCallToActionClick={isAuthenticated ? () => navigate('/gallery') : () => navigate('/waitlist')}/>
            </Box>
            
            <Box id="steps" mt={isMobile ? '0' : 'xl'}>
                <FeaturesSection/>
            </Box>
            
            <Box id="features">
                <FeaturesGrid/>
            </Box>
            
            <Box id="pricing" mt={0} style={{ flex: 1 }}>
                <PricingCards/>
            </Box>
            <Footer/>
        </Stack>
    );
}

